export enum FuelType {
  PETROL = 'petrol',
  DIESEL = 'diesel',
  ELECTRIC = 'electric',
}

export interface IFuelType {
  label: string;
  value: FuelType;
}

export const FuelTypes: IFuelType[] = [
  {
    label: 'Petrol',
    value: FuelType.PETROL,
  },
  {
    label: 'Diesel',
    value: FuelType.DIESEL,
  },
  {
    label: 'Electric',
    value: FuelType.ELECTRIC,
  },
];

export const getFuelTypeNameFromKey = (key: FuelType) => {
  return FuelTypes.find((ft) => ft.value === key)?.label ?? '';
};
